var _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCookieIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.829 28.086a1.934 1.934 0 011.174-.033c.987.257 2.083 1.34 1.853 2.646-.127.735-.152 1.493-.214 2.24a.966.966 0 00.752 1.052l3.622.952c.609.162.958-.003 1.245-.574.367-.735.733-1.474 1.103-2.212a2.362 2.362 0 012.05-1.247c.67-.033 1.32.23 1.778.72.553.607 1.1 1.213 1.642 1.817.321.404.9.49 1.325.197 1.053-.61 2.105-1.222 3.154-1.834.558-.324.704-.714.498-1.336-.238-.717-.487-1.436-.709-2.164a2.703 2.703 0 01-.154-.776c-.01-1.169 1.093-2.519 2.608-2.375.782.077 1.57.103 2.357.129l.113.003a.852.852 0 00.94-.722l.956-3.609a.965.965 0 00-.587-1.268c-.68-.32-1.353-.652-2.053-.923-1.494-.54-2.28-3.692-2.28-4.843l-5.753.767-.415-4.22-3.421-1.534-.78-6.26c-.303.658-.62 1.313-.89 1.98a2.296 2.296 0 01-1.326 1.31c-.873.344-2.026.211-2.688-.6-.514-.628-1.082-1.204-1.623-1.802a.955.955 0 00-1.234-.23 141.418 141.418 0 00-3.295 1.918.93.93 0 00-.43 1.22c.246.757.45 1.536.758 2.27.643 1.53-.91 3.4-2.565 3.154-.725-.109-1.458-.152-2.185-.214a1.014 1.014 0 00-1.15.811c-.314 1.182-.63 2.367-.942 3.552a.966.966 0 00.574 1.253c.72.362 1.434.738 2.164 1.082 1.41.668 1.807 2.81.541 3.892-.595.506-1.155 1.044-1.737 1.566-.508.455-.562.744-.224 1.353a963.352 963.352 0 001.701 3.065c.252.56.906.817 1.472.576.76-.245 1.52-.495 2.275-.75z",
    fill: "#242424",
    stroke: "#242424",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.668 26.406a1.934 1.934 0 011.174-.033c.987.257 2.083 1.34 1.853 2.646-.127.736-.152 1.493-.214 2.24a.966.966 0 00.752 1.052l3.622.952c.609.163.958-.002 1.244-.573.368-.736.733-1.474 1.104-2.213a2.362 2.362 0 012.05-1.247c.67-.033 1.32.23 1.778.72.553.607 1.1 1.213 1.642 1.817.32.404.9.49 1.325.198l3.154-1.834c.557-.325.704-.714.498-1.337-.238-.716-.487-1.436-.709-2.164a2.706 2.706 0 01-.154-.776c-.01-1.169 1.093-2.518 2.608-2.375.782.078 1.57.103 2.357.129l.112.003a.852.852 0 00.942-.722l.955-3.608a.966.966 0 00-.587-1.269c-.68-.32-1.353-.652-2.053-.922-1.494-.541-2.28-3.693-2.28-4.844l-5.754.768-.414-4.22-3.421-1.534-.78-6.26c-.303.657-.62 1.312-.89 1.98a2.297 2.297 0 01-1.326 1.31c-.873.343-2.026.21-2.689-.601-.514-.628-1.082-1.204-1.623-1.802a.955.955 0 00-1.233-.23 141.332 141.332 0 00-3.295 1.918.93.93 0 00-.43 1.22c.246.758.45 1.537.757 2.27.644 1.53-.908 3.4-2.564 3.154-.725-.108-1.458-.152-2.186-.214a1.014 1.014 0 00-1.15.812c-.313 1.182-.63 2.367-.94 3.551a.966.966 0 00.573 1.253c.72.362 1.434.738 2.164 1.082 1.41.668 1.807 2.81.54 3.892-.594.506-1.154 1.045-1.736 1.567-.508.454-.562.744-.224 1.352A974.415 974.415 0 004.92 26.58c.252.561.906.817 1.472.576.76-.245 1.52-.495 2.275-.75z",
    fill: "#E7E9FD",
    stroke: "#242424",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.811,
    cy: 14.934,
    r: 2.302,
    fill: "#242424"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.06,
    cy: 6.493,
    r: 2.302,
    fill: "#242424"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.196,
    cy: 22.221,
    r: 1.151,
    fill: "#242424"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.484,
    cy: 15.698,
    r: 1.534,
    fill: "#242424"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.54,
    cy: 7.643,
    r: 1.151,
    fill: "#242424"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.703,
    cy: 3.041,
    r: 1.151,
    fill: "#242424"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.648,
    cy: 9.558,
    r: 1.534,
    fill: "#242424"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.32,
    cy: 23.372,
    r: 2.302,
    fill: "#242424"
  })));
}

export default SvgCookieIcon;